// frontend/src/components/UI/DepartmentTradeChips.js
import React from 'react';
import { InfoBadge } from './InfoBadge';
import { TradeBadge } from './TradeBadge';
import {
  getDepartmentBadgeColor,
  getDepartmentShortName,
} from '../../config/departmentConfig';
import { isTradeRedundantWithDepartment } from '../../config/tradeConfig';

/**
 * Department + trade identity chips for dense HR tables and lists.
 *
 * Dept is the primary org signal (unique color + short name). Trade only
 * renders when it adds disambiguation — when trade equals department name
 * or shortName (Safety→Safety, DfMA→DfMA), the trade chip is suppressed.
 *
 * @param {string} [department] - Full department_name
 * @param {string|object} [trade] - trade_code string, trade name, or TradeCategory-like
 * @param {'stack'|'inline'} [layout] - stack for table cells; inline for meta rows
 * @param {'xs'|'md'} [size] - InfoBadge / TradeBadge size (default xs)
 * @param {string} [className]
 */
export const DepartmentTradeChips = ({
  department,
  trade,
  layout = 'stack',
  size = 'xs',
  className = '',
}) => {
  const deptName = department && department !== 'Unassigned' ? department : null;
  const showTrade =
    Boolean(trade) &&
    trade !== 'No Trade' &&
    !isTradeRedundantWithDepartment(deptName || department, null, null, trade);

  const layoutClass =
    layout === 'inline'
      ? 'inline-flex flex-wrap items-center gap-1.5'
      : 'flex flex-col items-start gap-0.5';

  return (
    <div className={`${layoutClass} ${className}`.trim()}>
      <InfoBadge
        color={deptName ? getDepartmentBadgeColor(deptName) : 'gray'}
        label={deptName ? getDepartmentShortName(deptName) : 'Unassigned'}
        title={deptName || 'Unassigned'}
        size={size}
      />
      {showTrade && <TradeBadge trade={trade} size={size} />}
    </div>
  );
};

export default DepartmentTradeChips;
